import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';
import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  signUpWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  signUpContentWrapper: {
    ...theme.mixins.appContainer,
    width: '480px',
    padding: theme.spacing(4, 2),

    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      height: '100%',
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  desktopLanguageSelector: {
    position: 'fixed',
    top: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: theme.zIndex.appBar,
  },
  mobileLanguageSelector: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  signUpForm: {
    width: '100%',
  },

  signUpRole: {
    textTransform: 'capitalize',
  },

  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },

  signUpForgotPasswordButton: {
    width: '100%',
    textAlign: 'right',
    marginTop: '8px',
    marginBottom: '32px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 400,
    fontSize: '12px',

    a: {
      color: theme.palette.primary.main,

      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
  },
  signUpModeSwitcher: {
    textAlign: 'center',
    width: '100%',
    marginTop: '24px',
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.font.secondary,
  },

  signUpSubmitButton: {
    marginTop: '16px',
  },
  agreementsCheckbox: {
    marginTop: theme.spacing(1),
    marginLeft: 0,
    alignItems: 'center',

    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      lineHeight: theme.typography.body1.lineHeight,
      color: theme.palette.font.secondary,
    },
  },
  agreementsCheckboxError: {
    border: `1px solid ${theme.palette.error.main}`,
    backgroundColor: alpha(theme.palette.error.main, UiAlpha.Tint),
    borderRadius: 10,
    padding: theme.spacing(1.5),
    boxSizing: 'border-box',
  },
  signUpModeSwitcherButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  signUpDivider: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '16px',
    color: theme.palette.font.secondary,
  },
  signUpButtonWithIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),

    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
}));
